import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Alert } from "melco-ui";

const LoginFormStatusMessage: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

 
  return null;
};

export default LoginFormStatusMessage;
